module.exports = __webpack_public_path__ + "static/media/trophy-2.3cd59c55.svg";